"use client";

import { useTranslations } from "next-intl";

export function PartnersSection() {
	const t = useTranslations();

	return (
		<section className="py-12 lg:py-20 bg-transparent">
			<div className="container text-center">
				<h2 className="text-3xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600">
					{t("common.footer.partners.title")}
				</h2>
				<div className="col-span-full flex flex-wrap justify-center gap-6">
					<a
						href="https://twelve.tools"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="https://twelve.tools/badge0-white.svg"
							alt="Featured on Twelve Tools"
							width="200"
							height="54"
							className="rounded-sm"
						/>
					</a>
					<a
						href="https://startupfa.me/s/imageprompt?utm_source=imageprompt.co"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="https://startupfa.me/badges/featured-badge.webp"
							alt="Featured on Startup Fame"
							width="171"
							height="54"
						/>
					</a>
					<a
						href="https://toolpilot.ai"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="https://www.toolpilot.ai/cdn/shop/files/f-w_690x151_crop_center.png"
							alt="toolpilot.ai"
							width="171"
							height="54"
							className="rounded-sm"
						/>
					</a>
					<a
						href="https://code.market?code.market=verified"
						target="_blank"
						rel="noopener noreferrer"
						title="ai tools code.market"
					>
						<img
							src="https://code.market/assets/manage-product/featured-logo-bright.svg"
							alt="ai tools code.market"
							title="ai tools code.market"
							width="171"
							height="54"
							className="rounded-sm"
						/>
					</a>
					<a
						href="https://dang.ai/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="https://cdn.prod.website-files.com/63d8afd87da01fb58ea3fbcb/6487e2868c6c8f93b4828827_dang-badge.png"
							alt="Dang.ai"
							className="w-[150px] h-[54px]"
							width="150"
							height="54"
						/>
					</a>
				</div>
			</div>
		</section>
	);
}
